// extracted by mini-css-extract-plugin
export default {"number":"Steps__number-ciKx","steps":"Steps__steps-rkrA","stepsCard":"Steps__stepsCard-hBNC","innerSvg":"Steps__innerSvg-JmjJ"};